import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'scrollPagination',
  props: {
    pageNo: {
      // 当前页码数
      type: Number,
      default: 1
    },
    pageSize: {
      // 一页加载的数量
      type: Number,
      default: 10
    },
    totalPage: {
      // 总条数
      type: Number,
      default: 1
    },
    range: {
      type: Number,
      default: 50
    },
    scrollId: {
      type: String,
      default: 'scrollId'
    },
    scrollbarTag: {
      type: String,
      default: 'ul'
    },
    moveUp: {
      // 是否允许向上移动
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      pageNum: 1
    };
  },
  watch: {
    scrollPageNo: function scrollPageNo(newValue, oldValue) {
      this.pageNum = newValue;
    }
  },
  computed: {
    scrollPageNo: function scrollPageNo() {
      return this.pageNo;
    },
    scrollTotalPage: function scrollTotalPage() {
      return Math.floor(this.totalPage / this.pageSize);
    }
  },
  mounted: function mounted() {
    this.pageNum = this.pageNo;
  },
  methods: {
    scrollbar: function scrollbar(value) {
      if (this.pageNum <= this.scrollTotalPage) {
        this.scrollbarScrollTop = value.scrollTop;
        var boxHeight = this.getVisibleHeight(document.querySelectorAll("#".concat(this.scrollId))[0]);
        var viewHeight = this.getVisibleHeight(document.querySelectorAll("#".concat(this.scrollId, " .scroll-pagination-view"))[0]);

        if (this.scrollbarScrollTop + boxHeight + this.range > viewHeight) {
          this.pageNum++;
          this.$emit('changePage', this.pageNum);
        }
      }
    },
    getScrollTop: function getScrollTop(element) {
      if (element === window) {
        return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop);
      }

      return element.scrollTop;
    },
    getVisibleHeight: function getVisibleHeight(element) {
      if (element === window) {
        return document.documentElement.clientHeight;
      }

      return element.clientHeight;
    }
  }
};